<template>
  <label class="sm-dropdown-preformat">
    <span 
      v-if="showLabel"
      class="sm-small"
      :class="{
        'sm-error': error
      }"
    >Country</span>
    <dropdown-block
      v-model="selectedCountry"
      class="sm-dropdown scroll-y"
      :class="{
        'error': error
      }"
      :ref="'elem'"
      :allow-empty="false"
      :options="countryList"
      :searchable="isSearchable"
      :close-on-select="true"
      :clear-on-select="true"
      :preselect-first="true"
      :placeholder="'Select country'"
      :custom-label="setCustomLabel"
      track-by="name"
      @input="handleSelect"
      @open="dropdownActive = true"
      @close="dropdownActive = false"
      :disabled="disabled"
    >
      <template slot="singleLabel" slot-scope="props" :value="props.option.id">
        <span>
          <include-flag :country="props.option.name" />
          {{ props.option.name }}
        </span>
        <include-svg :name="'icon-arrow-b'" />
      </template>
      <template slot="noOptions">
        <span>Loading...</span>
      </template>
      <template slot="option" slot-scope="props" :value="props.option.id">
        <include-flag :country="props.option.name" />
        <span class="sm-txt-capitalize">{{ props.option.name }}</span>
      </template>
    </dropdown-block>
    <span 
      v-if="error"
      class="sm-tiny sm-error"
    >{{error}}</span>
  </label>
</template>

<script>
import Multiselect from 'vue-multiselect';
import IncludeFlag from '@/components/IncludeFlag';
import DropdownKeyEvents from '@/mixins/DropdownKeyEvents';

export default {
  name: 'country-dropdown',
  components: {
    'dropdown-block': Multiselect,
    'include-flag': IncludeFlag,
  },
  props: {
    countryList: {
      type: Array,
      default: () => []
    },
    startVal: {
      type: Object,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {}
  },
  data() {
    return {
      selectedCountry: {
        id: null,
        code: '',
        name: '',
        phone_prefix: '',
        states: []
      }
    };
  },
  created() {
    if (this.startVal)
      this.selectedCountry = this.startVal;
  },
  mixins: [DropdownKeyEvents],
  methods: {
    handleSelect(e) {
      this.$emit('input', this.selectedCountry);
      this.$refs.elem.isOpen = false;
    },
    setCustomLabel(item) {
      return (`${item.name} ${item.code}`).toLowerCase();
    }
  },
  watch: {
    startVal(val) {
      if (val != this.selectedCountry)
        this.selectedCountry = val;
    }
  }
}
</script>